export default __webpack_public_path__ + "static/media/ECOLAB.fcb46750.png";